"use strict";

class CustomerUnitItemController {

    constructor(
        $scope, $localStorage, $interval, $timeout, $sce, $window, $cookies, $location, $parse, $anchorScroll, $document,
        Upload, Fullscreen,
        SSHttpService, SSUtilService, SSConfigService, SSAppService, SSUserService, SSDisclaimerService, OTPService
    ) {
        const self = this;

        self.$scope = $scope;
        self.$localStorage = $localStorage;
        self.$interval = $interval;
        self.$timeout = $timeout;
        self.$sce = $sce;
        self.$window = $window;
        self.location = $location;
        self.$parse = $parse;
        self.anchorScroll = $anchorScroll;
        self.document = $document;
        self.$cookies = $cookies;

        self.Upload = Upload;
        self.Fullscreen = Fullscreen;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSConfigService = SSConfigService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSDisclaimerService = SSDisclaimerService;
        self.OTPService = OTPService;

        self.STATE_NONE = 0;
        self.STATE_BEGIN = 1;
        self.STATE_ASK_FOR_OFFER = 2;
        self.STATE_SHOW_TERMS = 3;
        self.STATE_SHOW_TSDR = 4;
        self.STATE_PREPARING_FOR_BOOKING = 5;
        self.STATE_STEP_0_STEPS = 6;
        self.STATE_STEP_1_OTP = 7;
        self.STATE_STEP_2_UPLOAD_DOC = 8;
        self.STATE_STEP_3_DEV_DOC = 9;
        self.STATE_STEP_4_SELECT_AGENT = 10;
        self.STATE_STEP_5_CONFIRMATION = 11;

        self.BROKER_TYPE_MAIN = 1;
        self.BROKER_TYPE_CO = 2;

        self.USER_BUYER_TYPE_PRIMARY = 1;

        self.ASSET_MODEL = {
            UserBuyerDocument: 1
        };
        self.PROMOTION_DISCOUNT_TYPE = {
            AMOUNT: 1,
            PERCENTAGE: 2
        };

        self.PROPERTY_TYPE_PRIVATE_CONDO = 1;
        self.PROPERTY_TYPE_EXECUTIVE_CONDO = 2;
        self.PROPERTY_TYPE_LANDED = 3;
        self.PROPERTY_TYPE_APARTMENT = 4;
        self.PROPERTY_TYPE_INTERGATED_DEVELOPMENT = 5;
        self.PROPERTY_TYPE_COMMERCIAL = 6;

        self.url = "";
        self.thumbFile = null;

        self.appServiceObject = self.SSUtilService.defineStorageDefault('def_app_service');

        self.scanDocumentStatus = false;
        self.video = '';
        self.startCapture = '';
        self.doneCapture = '';
        self.blobObj = '';
        self.userBuyer = '';
        self.buyerDocument = '';
        self.localMediaStream = '';
        self.camErrorMsg = false;
        self.waitngMsg = true;
        self.installAdobe = false;
        self.scanShow = true;

        self.FLOORPLAN_ASSET_TYPE_FLOOR_PLAN_IMAGE = SHOWSUITE.FLOORPLAN_ASSET_TYPE_FLOOR_PLAN_IMAGE;
        self.FLOORPLAN_ASSET_TYPE_KEY_IMAGE = SHOWSUITE.FLOORPLAN_ASSET_TYPE_KEY_IMAGE;
        self.FLOORPLAN_ASSET_TYPE_DIRECTION_IMAGE = SHOWSUITE.FLOORPLAN_ASSET_TYPE_DIRECTION_IMAGE;
        self.FLOORPLAN_ASSET_TYPE_DOCUMENT = SHOWSUITE.FLOORPLAN_ASSET_TYPE_DOCUMENT;
        self.FLOORPLAN_ASSET_TYPE_360_IMAGE = SHOWSUITE.FLOORPLAN_ASSET_TYPE_360_IMAGE;

        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED;

        self.PROPERTY_PRODUCT_MARKETING_SUITE_2D = SHOWSUITE.PROPERTY_PRODUCT_MARKETING_SUITE_2D;

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;

        self.UNIT_PRICE_TYPE_FIXED = SHOWSUITE.UNIT_PRICE_TYPE_FIXED;

        self.SMS_VALIDATION_TYPE_BOOKNOW = SHOWSUITE.SMS_VALIDATION_TYPE_BOOKNOW;

        self.IDENTITY_TYPE_SINGAPOREAN = SHOWSUITE.IDENTITY_TYPE_SINGAPOREAN;
        self.IDENTITY_TYPE_SINGAPORE_PR = SHOWSUITE.IDENTITY_TYPE_SINGAPORE_PR;
        self.IDENTITY_TYPE_FOREIGNER = SHOWSUITE.IDENTITY_TYPE_FOREIGNER;

        self.PROPERTY_DOCUMENT_TYPE_FORM = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_FORM; // Downloadable file provided by developer for buyer to fill
        self.PROPERTY_DOCUMENT_TYPE_USER_DOC = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_USER_DOC; // Document file required from buyer e.g; passport copy

        self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_BACK;
        self.PROPERTY_DOCUMENT_KIND_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PASSPORT;
        self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;

        self.successBuyer = false;
        self.showSocialModal = false;

        self.data = SHOWSUITE.data;
        self.callButtonActive = false;

        try {
            self.booknowSessionMinutes = self.SSAppService.getServerConfig().booknow_session_minutes;
        } catch (ex) {
        }

        // $window.addEventListener('DocumentSignedEvent', function (event) {
        //     self.signDeveloperForm(event.detail);
        // }, false);

        window.onmessage = function (e) {
            if (!e.origin.match(/http[s]?:\/\/.*\.showsuite.com/)) {
                return;
            }

            if (e.data.event == 'DocumentSignedEvent') {
                self.signDeveloperForm(e.data.status);
            }
        };

        self.init();
    }

    init() {
        const self = this;
        self.language = self.$localStorage['language'];
        self.$scope.$watch(() => self.SSUserService.getUser(), function (user) {
            if (user && self.initBookingLoginRequired) {
                self.initBooking();
            }
        });
        self.floorPlan3dLoaded = false;
        self.viewUnitPropertyDescription = null;
        self.truncateDescription = null;

        self.resetVars();

        self.getUnitDetails();
        if (self.data.share_code) {
            self.prepareLoadShareCode();
        }
        self.checkCallButtonActive();

        self.scrollToLink();
        $('#return-to-top').hide();

        $(window).scroll(function() {
          if ($(this).scrollTop() >= 300) {        // If page is scrolled more than 300px
              $('#return-to-top').fadeIn(200);    // Fade in the arrow
          } else {
              $('#return-to-top').fadeOut(200);   // Else fade out the arrow
          }
        });

        $('#return-to-top').click(function() {      // When arrow is clicked
          $('body,html').animate({
              scrollTop : 0                       // Scroll to top of body
          }, 500);
        });

        //Detect should display unit specification section
        self.displayUnitSpecification = false;

        if((self.unit.utility_toilet
                || self.unit.bath_tub
                || self.unit.study
                || self.unit.store_rooms
                || self.unit.household_shelter
                || self.unit.utility_room
                || self.unit.kitchen_type
                || self.unit.wet_kitchen
                || self.unit.balcony
                || self.unit.planter
                || self.unit.service_yard)
            || (self.unit.tiling_master 
                    || self.unit.tiling_rooms
                    || self.unit.flooring_rooms
                    || self.unit.flooring_kitchen
                    || self.unit.flooring_living_dining)
            || (self.unit.appliances && self.unit.appliances.length)
            || (self.unit.specifications && self.unit.specifications.length)
            || (self.unit.special_spaces && self.unit.special_spaces.length)
            || (self.unit.options && self.unit.options.length)) {
            self.displayUnitSpecification = true;
        }

        if (SHOWSUITE.data.viewMode) {
            if (SHOWSUITE.data.viewMode === '360') {
                self.$timeout(function () {
                    let photoDiv = document.getElementById('photo');

                    if (photoDiv) {
                        photoDiv.scrollIntoView();
                    }
                }, 500);
            } else if (SHOWSUITE.data.viewMode === '3dmodel') {
                self.$timeout(function () {
                    let floorPlanDiv = document.getElementById('floor-plan');

                    if (floorPlanDiv) {
                        floorPlanDiv.scrollIntoView();
                    }
                }, 500);
            }
            
        }
    }

    initLocaleString(){
        const self = this;
        self.localeStrings = [];

        self.localeStrings['property.' + self.property.id + '.name'] = self.toLocaleDictionary('properties',self.property.id,'name',self.property.name);
        self.localeStrings['property.' + self.property.id + '.location'] = self.toLocaleDictionary('properties',self.property.id,'location',self.property.location);
        self.localeStrings['unit.' + self.unit.id + '.type'] = self.toLocaleDictionary('units',self.unit.id,'type',self.unit.name);
        self.localeStrings['floorplan.' + self.unit.floor_plan_id + '.name'] = self.toLocaleDictionary('floorplans',self.unit.floor_plan_id,'name',self.unit.floor_plan);
        self.localeStrings['floorplan.' + self.unit.floor_plan_id + '.appliances'] = self.toLocaleDictionary('floorplans',self.unit.floor_plan_id,'appliances',self.unit.appliances);
        self.localeStrings['floorplan.' + self.unit.floor_plan_id + '.special_spaces'] = self.toLocaleDictionary('floorplans',self.unit.floor_plan_id,'special_spaces',self.unit.special_spaces);
        self.localeStrings['floorplan.' + self.unit.floor_plan_id + '.features'] = self.toLocaleDictionary('floorplans',self.unit.floor_plan_id,'features',self.unit.features);
        self.localeStrings['floorplan.' + self.unit.floor_plan_id + '.options'] = self.toLocaleDictionary('floorplans',self.unit.floor_plan_id,'options',self.unit.options);
        self.localeStrings['floorplan.' + self.unit.floor_plan_id + '.specifications'] = self.toLocaleDictionary('floorplans',self.unit.floor_plan_id,'specifications',self.unit.specifications);
    }

    toLocaleDictionary(table ,id, column_name, original_value){
        const self = this;

        if(!table || !id || !column_name)
            return original_value;

        if(self.$cookies.get('lang') == 'en')
            return original_value;

        if(self.language){
            let result = self.language.filter(function (row) {

                return table+'.'+id+'.'+column_name+'.'+self.$cookies.get('lang') == row.key;
            });
            if(result.length && result[0].value != '')
                return result[0].value ;
            else
                return original_value;
        }
    }

    getPropertyContactNumber() {
        const self = this;

        let url = "properties/" + self.property.id + "/contact-details";
        let params = {
            'unitId': self.unit.id
        };
    
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property.contact_info = response.data;
            
            if (!self.property.contact_info.hasOwnProperty("photo") || !self.property.contact_info.photo) {
                self.property.contact_info.photo = self.property.developer.logo_file;
            }

            if (self.property.contact_info && !self.property.contact_info.phone1) {
                self.property.contact_info.phone1 = self.property.contact_number;
            }
            
            $('#call-modal').modal('show');

            self.hasCalledPropertyContactAPI = true;
       });
    }

    scrollToLink() {
        $('.in-page-nav a[href^="#"], .project-view-info a[href^="#"]').on("click", function(e) {
            e.preventDefault();
            var $a = $(this),
            href = $a.attr("href");
            var $target = $(href);
            if(!$target.length) { return; }
            $("html, body").animate({
            scrollTop : $target.offset().top
            });
        });
    }

    getUnitDetails() {
        const self = this;

        self.property = self.data.property;
        self.stack = self.data.stack;
        self.unit = self.data.unit;
        self.initLocaleString();

        self.unit.offer_price = self.unit.price;

        self.bookButtonText = self.unitHasFixedPrice() ? 'BOOK NOW' : 'MAKE AN OFFER';

        self.unit.floor_plan_3d = self.$sce.trustAsResourceUrl(self.unit.floor_plan_3d);

        self.unit.appliances = self.toArray(self.localeStrings['floorplan.' + self.unit.floor_plan_id + '.appliances']);
        self.unit.special_spaces = self.toArray(self.localeStrings['floorplan.' + self.unit.floor_plan_id + '.special_spaces']);
        self.unit.features = self.toArray(self.localeStrings['floorplan.' + self.unit.floor_plan_id + '.features']);
        self.unit.options = self.toArray(self.localeStrings['floorplan.' + self.unit.floor_plan_id + '.options']);
        self.unit.specifications = self.toArray(self.localeStrings['floorplan.' + self.unit.floor_plan_id + '.specifications']);

        self.assetsFloorPlanImgs = [];
        self.assetsDroneImgs = [];
        self.assetsKeyImgs = [];
        self.assetsDirectionImgs = [];
        self.assetsSpecPdfs = [];
        self.assets360Imgs = [];

        if (self.unit.unit_assets) {
            _.forEach(self.unit.unit_assets, function (asset) {
                switch (asset.type) {
                    case self.FLOORPLAN_ASSET_TYPE_FLOOR_PLAN_IMAGE:
                        self.assetsFloorPlanImgs.push(asset);
                        break;
                    case self.FLOORPLAN_ASSET_TYPE_KEY_IMAGE:
                        self.assetsKeyImgs.push(asset);
                        break;
                    case self.FLOORPLAN_ASSET_TYPE_DIRECTION_IMAGE:
                        self.assetsDirectionImgs.push(asset);
                        break;
                    case self.FLOORPLAN_ASSET_TYPE_DOCUMENT:
                        self.assetsSpecPdfs.push(asset);
                        break;
                    case self.FLOORPLAN_ASSET_TYPE_360_IMAGE:
                        self.assets360Imgs.push(asset);
                        break;
                }
            });
        }

        self.setDefaultImages();
        self.SSAppService.isPageLoaded = true;

        if (self.SSUserService.getUser() && self.SSUserService.userStorageObject.initiateBooking) {
            self.SSUserService.userStorageObject.initiateBooking = false;
            self.initBooking();
        }

        self.trackUnitViews();
    }

    toArray(str) {
        let array = [];

        if (str) {
            jQuery.each(str.split("\n"), function (i, v) {
                if (v) {
                    array.push(v);
                }
            });
        }

        return array;
    }

    setDefaultImages() {
        const self = this;

        if ((self.assetsFloorPlanImgs && self.assetsFloorPlanImgs.length > 0)) {
            self.viewMedia = 'floor_plan';
        } else if (self.assetsDroneImgs && self.assetsDroneImgs.length > 0) {
            self.viewMedia = 'drone';
        } else if (self.assetsDirectionImgs && self.assetsDirectionImgs.length > 0) {
            self.viewMedia = 'direction';
        } else if (self.assetsKeyImgs && self.assetsKeyImgs.length > 0) {
            self.viewMedia = 'photos';
        }
    }

    viewMediaClick(value) {
        const self = this;

        if (value == 'floor_plan' && self.assetsFloorPlanImgs && self.assetsFloorPlanImgs.length > 0) {
            self.viewMedia = value;
        } else if (value == 'drone' && self.assetsDroneImgs && self.assetsDroneImgs.length > 0) {
            self.viewMedia = value;
        } else if (value == 'direction' && self.assetsDirectionImgs && self.assetsDirectionImgs.length > 0) {
            self.viewMedia = value;
        } else if (value == 'photos' && self.assetsKeyImgs && self.assetsKeyImgs.length > 0) {
            self.SSDisclaimerService.getAccepted(
                'PROPERTY_' + self.property.id + '_UNIT_PHOTOS',
                self.SSDisclaimerService.MESSAGE_UNIT_PHOTOS_VIEW,
                self.SSDisclaimerService.STORAGE_LOCAL,
                function () {
                    self.viewMedia = value;
                }
            );
        } else if (value == '3d') {
            self.hide3dPlaceholder = true;
            if (self.viewMedia == '3d') {
                self.setDefaultImages();
            } else {
                self.SSDisclaimerService.getAccepted(
                    'PROPERTY_' + self.property.id + '_FLOORPLAN_3D_MODEL',
                    self.SSDisclaimerService.MESSAGE_UNIT3D_VIEW,
                    self.SSDisclaimerService.STORAGE_LOCAL,
                    function () {
                        self.show3dView();
                    }
                );
            }
        } else if (value == '360_photos' && self.assets360Imgs && self.assets360Imgs.length > 0) {
            self.hide360Placeholder = true;
            self.viewMedia = value;
        }
    }

    show3dView() {
        const self = this;

        if (!self.floorPlan3dLoaded) {
            self.floorPlan3dLoaded = true;
            self.viewMedia = '3dLoading';
            self.$timeout(function () {
                self.viewMedia = '3d';
            }, 9000);
        } else {
            self.viewMedia = '3d';
        }

        var url = 'track/view/trackPropertyUnitThreeDView/' + self.unit.id;
        var params = {
            unit_id: self.unit.id,
            property_type: "unit"
        };

        self.SSHttpService.postAPIRequest(url, params).then(function (responseObj) {
            if (responseObj instanceof Error) {
                console.log(responseObj.message + "\n" + JSON.stringify(responseObj.data));
                return;
            }
        });
    }

    resetVars() {
        const self = this;

        self.sale = null;
        self.buyersList = null;
        self.saleBuyers = null;
        self.saleBuyer = null;
        self.propertyDocuments = null;
        self.brokersList = null;
        self.developerForms = []; //filtered array of only property documents
        self.buyerDocuments = [];
        self.own_hdb = "no";
        self.own_other = "no";
        self.selectedBroker = null;
        self.saleLoading = false;
        self.saleSuccess = false;
        self.saleErrorMessage = null;

        self.bookNowSessionOTP = false;
        self.twofa_code = null;

        self.documentToSign = null;

        //controller states:
        self.bookingState = self.STATE_NONE;
        self.proceedButtonEnabled = false;
    }

    /**
     * @param type ['danger', 'warning', 'success', 'info']
     * @param message message to display
     */

    setUserMessage(type, message) {
        const self = this;
        self.userMessageType = type;
        self.userMessage = message;
    }

    unitHasFixedPrice() {
        var self = this;

        return self.unit && self.unit.price_type == self.UNIT_PRICE_TYPE_FIXED;
    }

    initBooking() {
        var self = this;

        if (!self.SSUserService.getUser()) {
            self.initBookingLoginRequired = true;
            self.SSUserService.userStorageObject.initiateBooking = true;
            self.SSUserService.showLoginModal();
            return;
        }

        if (self.unitHasFixedPrice()) {
            self.bookingState = self.STATE_SHOW_TERMS;
        } else {
            self.bookingState = self.STATE_ASK_FOR_OFFER;
        }
    }

    sessionOpen() {
        var self = this;

        self.resetVars();

        self.bookNowSessionOTP = false;
        self.twofa_code = null;
        self.bookingState = self.STATE_PREPARING_FOR_BOOKING;
        self.setUserMessage('info', 'Please wait while we prepare for booking session to start.');

        let params = {
            unit_id: self.unit.id,
            offer_price: self.unit.offer_price,
            include: 'sale_gst_detail'
        };

        self.SSHttpService.postAPIRequest('sec/sales/session/open', params).then(
            function (responseObj) {
                if (responseObj instanceof Error) {
                    if (responseObj.code == 401) {
                        self.SSUserService.clearUser();
                        self.SSUserService.showLoginModal();
                        self.setUserMessage('danger', 'Unauthorised! You cannot perform this action. Please make sure you are logged in and has required permissions.');
                    } else if (responseObj.sub_code == 3) {
                        self.setUserMessage('danger', 'Unable to send SMS OTP. Please retry or contact Showsuite support.');
                    } else if (responseObj.sub_code == 4) {
                        self.setUserMessage('danger', 'Unable to send SMS OTP. Please make sure you have added a valid contact number in your Showsuite profile.');
                    } else if (responseObj.sub_code == 10) {
                        self.setUserMessage('danger', 'Error starting booking session. Another session is already open.');
                    } else {
                        self.setUserMessage('danger', 'Error starting booking session. Please retry or contact Showsuite support.');
                    }
                    return;
                }

                if (responseObj.sub_code == 0) {
                    self.sale = responseObj.data.sale;
                    self.initBookNow();
                } else {
                    self.errTwoFACode = '';
                    self.twoFALoadingIndicator = false;
                    self.bookNowSessionOTP = true;
                    jQuery('#bookNowSessionOTP').modal('show');
                }
            }
        );
    }

    verifyTwoFA() {
        const self = this;

        if (!self.twofa_code) {
            self.errTwoFACode = 'Required';
            return;
        }

        self.errTwoFACode = '';
        self.twoFALoadingIndicator = true;

        let params = {
            email: self.SSUserService.getUser().email,
            twofa_code: self.twofa_code,
            twofa_type: self.SMS_VALIDATION_TYPE_BOOKNOW,
            unit_id: self.unit.id,
            offer_price: self.unit.offer_price
        };

        self.SSHttpService.postAPIRequest('2fa', params).then(
            function (responseObj) {
                self.twoFALoadingIndicator = false;

                if (responseObj instanceof Error) {
                    self.errTwoFACode = "Invalid Code";
                    return;
                }

                self.bookNowSessionOTP = false;
                jQuery('#bookNowSessionOTP').modal('hide');

                self.sale = responseObj.data.sale;

                self.initBookNow();
            }
        );
    }

    sessionPing() {
        const self = this;

        if (self.saleSuccess) return;

        let params = {unit_id: self.unit.id};

        self.SSHttpService.postAPIRequest('sec/sales/session/ping', params).then(
            function (responseObj) {
                if (responseObj instanceof Error) {
                    self.resetVars();
                    self.setUserMessage('danger', 'Session has expired.');
                    return;
                }

                self.$timeout(function () {
                    self.sessionPing()
                }, 60000); // 1 min delay
            }
        );
    }

    sessionClose() {
        var self = this;

        self.resetVars();

        self.SSHttpService.postAPIRequest('sec/sales/session/close').then(
            function (responseObj) {
            }
        );
    }

    initBookNow() {
        const self = this;

        loading(true);

        self.setUserMessage('info', 'Please wait while we prepare for booking process...');

        self.getBuyers();
        self.getPropertyDocuments();
        self.getBrokers();
        self.getBrokerSocialLinks();

        self.startSessionTimer();
        self.sessionPing();

        if (self.sale.promotion_code) {
            self.checkPromotionCode();
        }
    }

    startSessionTimer() {
        const self = this;

        self.sessionMinutesLeft = null;
        self.sessionSecondsLeft = null;
        if (self.unitHasFixedPrice()) {
            self.sessionMinutesLeft = self.booknowSessionMinutes;
            self.sessionSecondsLeft = 0
            self.$interval(function () {
                self.sessionSecondsLeft -= 1;
                if (self.sessionSecondsLeft <= 0) {
                    self.sessionSecondsLeft = 60;
                    self.sessionMinutesLeft -= 1;
                    if (self.sessionMinutesLeft <= 0) {
                        self.sessionMinutesLeft = 0;
                        self.sessionSecondsLeft = 0;
                    }
                }
            }, 1000);
        }
    }

    getBuyers() {
        var self = this;

        self.SSHttpService.getAPIRequest('sec/buyers').then(
            function (responseObj) {

                if (responseObj instanceof Error) {
                    self.setUserMessage('info', 'Error fetching profile information to start booking process');
                    return;
                }

                //creating a list of buyers with original value, this will be a backup value incase update user fails, we can fetch the original value from this list.
                self.buyersListBackup = {};
                _.forEach(responseObj.data.buyers, function (buyerItem) {
                    self.buyersListBackup[buyerItem.id] = _.cloneDeep(buyerItem);
                });

                let mainBuyer = null;
                _.forEach(responseObj.data.buyers, function (buyerItem) {
                    buyerItem.selected = false;
                    buyerItem.isBusy = false;
                    if (buyerItem.type === self.USER_BUYER_TYPE_PRIMARY) {
                        mainBuyer = buyerItem;
                    }
                });
                console.log(responseObj.data.user);
                let user = null;
                user = responseObj.data.user;
                if(user)
                {
                    if(user.own_hdb == 1){
                        self.own_hdb = "yes"
                    }
                    else{
                        self.own_hdb = "no";
                    }
                    if(user.own_other_property == 1){
                        self.own_other = "yes";
                    }
                    else{
                        self.own_other = "no";
                    }

                }

                self.buyersList = responseObj.data.buyers;

                if (mainBuyer) {
                    mainBuyer.selected = true;
                    self.editBuyer(mainBuyer);
                }

                self.updatePreparingStatus();
            }
        );
    }

    getPropertyDocuments() {
        var self = this;

        self.SSHttpService.getAPIRequest(`sec/properties/${self.property.id}/documents`).then(
            function (responseObj) {

                if (responseObj instanceof Error) {
                    self.setUserMessage('info', 'Error fetching unit documents to start booking process');
                    return;
                }

                self.propertyDocuments = responseObj.data.property_documents;

                self.updatePreparingStatus();
            });
    }

    getBrokers() {
        var self = this;

        self.SSHttpService.getAPIRequest(`sec/properties/${self.property.id}/brokers?offset=0&limit=100`).then(
            function (responseObj) {
                if (responseObj instanceof Error) {
                    self.setUserMessage('info', 'Error fetching list of agents to start booking process');
                    return;
                }

                self.brokersList = responseObj.data.brokers;
                self.allBrokersList = responseObj.data.brokers;

                self.updatePreparingStatus();
            }
        );
    }

    updatePreparingStatus() {
        let self = this;
        if (self.buyersList !== null && self.propertyDocuments !== null && self.brokersList !== null && self.allBrokersList !== null) {

            //fill up buyer docs here as they require both buyers and docs
            self.developerForms = self.fillDeveloperForms(self.propertyDocuments);

            self.bookingState = self.STATE_STEP_0_STEPS;

            self.shallEnableProceedButton();

            self.setUserMessage(null, null);

            loading(false);
        }
    }

    editBuyer(buyerItem) {
        let self = this;

        self.cancelBuyer();

        buyerItem.modeUpdate = true;
        self.proceedButtonEnabled = false;
        self.showExistingBuyers = false;

        self.$timeout(function () {
            self.maskPhoneNumber(buyerItem);
            self.maskDate(buyerItem);
            self.onNationalityChange(buyerItem);
        }, 100);
    }

    maskPhoneNumber(context) {
        let self = this;

        if (!context || context.id === undefined || context.id === '') {
            return;
        }

        let form = jQuery('#buyerForm' + context.id);
        let contextPrefix = 'buyerItem.';

        jQuery.each(form.find('input[type=tel]'), function (i, el) {
            let field = jQuery(el);

            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                customPlaceholder: function (placeholder, country) {
                    return placeholder ? placeholder.replace(/[0-9]/g, "X") : placeholder;
                },
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);
                if (value) {
                    // Set and validate the number
                    field.intlTelInput('setNumber', value);
                    if (!field.intlTelInput("isValidNumber")) {
                        field.parent().addClass("has-danger");
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                    }
                }
            }

            field.on("keyup change", function () {
                field.parent().removeClass("has-danger");
            });
            field.blur(function () {
                let currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                let valueToDisplay = field.intlTelInput("getNumber", currentFormat);
                field.val(valueToDisplay);

                field.parent().removeClass("has-danger");
                if (!field.intlTelInput("isValidNumber")) {
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                    }

                    let required = field.attr('required');
                    required = required && required !== 'false';
                    if (required || valueToDisplay) {
                        field.parent().addClass("has-danger");
                    }
                } else {
                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }
            });
        });

    }

    maskDate(context) {
        let self = this;

        if (!context || context.id === undefined || context.id === '') {
            return;
        }

        let form = jQuery('#buyerForm' + context.id);
        let contextPrefix = 'buyerItem.';

        jQuery.each(form.find('input[type=jdate]'), function (i, el) {
            let field = jQuery(el);

            let options = {
                changeYear: true,
                yearRange: '-80:+0'
            };

            let maxDate = field.attr('jdate-max-date');
            if (maxDate) {
                options.maxDate = maxDate;
            }

            let model = field.attr('jdate-ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);
                if (value && Date.parse(value)) {
                    field.val(value);
                }
            }

            let dateFormat = field.attr('date-format');
            if (!dateFormat) {
                dateFormat = 'yy-mm-dd';
            }
            options.dateFormat = dateFormat;

            options.onSelect = function (dateText, inst) {
                if (model && dateText) {
                    self.$parse(model).assign(context, dateText);
                }
            };

            field.datepicker(options);

        });

    }

    addBuyer() {
        let self = this;

        self.cancelBuyer();

        let hasUnselectedBuyers = false;
        _.forEach(self.buyersList, function (buyerItem) {
            if (!buyerItem.selected) {
                hasUnselectedBuyers = true;
                return true;
            }
        });

        if (hasUnselectedBuyers) {
            self.showExistingBuyers = true;
        } else {
            self.addNewBuyer();
        }
    }

    addExistingBuyer(buyerId) {
        const self = this;

        _.forEach(self.buyersList, function (buyerItem) {
            if (buyerItem.id == buyerId) { // int == string comparison
                buyerItem.selected = true;
                self.editBuyer(buyerItem);
                self.shallEnableProceedButton();
                return true;
            }
        });

        self.showExistingBuyers = false;
    }

    addNewBuyer() {
        let self = this;

        self.cancelBuyer();

        let buyerItem = {
            "id": 0, // require >= 0, as it is used for id attribute on html page
            "selected": true,
            "modeUpdate": true, //local memory variable, so camelCase (no need for server)
        };
        self.buyersList.push(buyerItem);

        self.$timeout(function () {
            self.maskPhoneNumber(buyerItem);
            self.maskDate(buyerItem);
        }, 100);

        self.proceedButtonEnabled = false;
        self.showExistingBuyers = false;
    }

    isNewDataModel(dataModel) {
        return !(_.has(dataModel, 'id') && dataModel.id > 0);
    }

    shallEnableProceedButton(stepNumber = this.bookingState, goNextStep = false) {
        const self = this;
        self.proceedButtonEnabled = false;

        switch (stepNumber) {
            case self.STATE_STEP_0_STEPS:
                self.proceedButtonEnabled = true;
                break;
            case self.STATE_STEP_1_OTP:
                let selectedBuyers = [];
                let buyersSelectedAndReady = false;
                _.forEach(self.buyersList, function (buyer) {
                    if (buyer.selected) {
                        selectedBuyers.push(buyer);
                    }
                });

                _.forEach(selectedBuyers, function (buyer) {
                    if (buyer.modeUpdate) {
                        buyersSelectedAndReady = false;
                        return false;
                    } else {
                        buyersSelectedAndReady = true;
                    }
                });
                self.proceedButtonEnabled = buyersSelectedAndReady && self.own_hdb != null && self.own_other != null;

                break;
            case self.STATE_STEP_2_UPLOAD_DOC:

                //document.body.style.width = '98%';
                let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                let isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);

                if (isSafari || isIE) {
                    self.scanShow = false;
                } else {
                    self.scanShow = true;
                }

                let allDocumentsUploaded = true;
                self.proceedButtonEnabled = false;
                _.forEach(self.buyersList, function (buyerItem) {
                    if (buyerItem.selected) {
                        _.forEach(self.buyerDocuments[buyerItem.id], function (buyerDocument) {
                            console.log(JSON.stringify(buyerDocument));
                            if (self.isNewDataModel(buyerDocument)) {
                                allDocumentsUploaded = false;
                            }
                            self.proceedButtonEnabled = allDocumentsUploaded;
                        });
                    }
                });

                break;
            case self.STATE_STEP_3_DEV_DOC:
                self.proceedButtonEnabled = false;
                let allDocumentsSigned = true;
                if (self.saleBuyers) {
                    _.forEach(self.saleBuyers, function (saleBuyer) {
                        if (saleBuyer.type === self.USER_BUYER_TYPE_PRIMARY && saleBuyer.sale_documents) {
                            _.forEach(saleBuyer.sale_documents, function (saleDocument) {
                                if (!saleDocument.signed) {
                                    allDocumentsSigned = false;
                                }
                            });

                        }

                    });
                }
                self.proceedButtonEnabled = allDocumentsSigned;
                break;
            case self.STATE_STEP_4_SELECT_AGENT:

                if (self.isCoBrokerEnabled) {
                    self.proceedButtonEnabled = (self.selectedBroker != null && self.selectedCoBroker != null && self.selectedBroker != self.selectedCoBroker);
                } else {
                    self.proceedButtonEnabled = self.selectedBroker != null;
                }

                break;
        }
        if (goNextStep) {
            if(self.successBuyer){
                self.successBuyer = false;
                let finalObj = {
                    "others": {
                        "own_hdb": self.own_hdb,
                        "own_other": self.own_other
                    },
                };

                self.saleLoading = true;
                loading(true);

                self.SSHttpService.postAPIRequest(`sec/sales/updateProperty`, finalObj).then(
                    function (responseObj) {

                        //self.saleLoading = false;
                        //loading(false);

                        if (responseObj instanceof Error) {
                            return;
                        }
                    });

            }
            self.goNextStep();
        }
    }

    goNextStep() {
        let self = this;

        if (!self.proceedButtonEnabled) return;

        if (self.bookingState == self.STATE_STEP_1_OTP) {
            if (!self.saleBuyers) {
                self.saveSaleBuyers();
                return;
            }
        } else if (self.bookingState + 1 == self.STATE_STEP_5_CONFIRMATION) {
            self.finalizeSale();
        }

        self.bookingState++;

        self.setUserMessage(null, null);

        //re calculate self.proceedButtonEnabled
        self.shallEnableProceedButton();

    }

    goPreviousStep() {
        let self = this;
        if (self.bookingState - 1 >= self.STATE_STEP_1_OTP) {
            self.bookingState--;
        }

        if (self.bookingState == self.STATE_STEP_1_OTP) {
            self.saleBuyers = null;
        }

        //re calculate self.proceedButtonEnabled
        self.shallEnableProceedButton();
    }

    getBrokerSocialLinks() {
        let self = this;
        self.SSHttpService.getAPIRequest(`sec/broker-social-link/${self.property.id}`).then(
            function (responseObj) {
                if (responseObj instanceof Error) {
                    self.setUserMessage('info', 'Error fetching agent social links');
                    return;
                }
                self.brokerSocialLinks = responseObj.data.broker_social_links;
                self.selectDefaultBroker();
            }
        );
    }

    selectDefaultBroker() {
        let self = this;
        if (!self.brokerSocialLinks || self.brokerSocialLinks.length == 0) return;

        self.selectedBroker = self.brokerSocialLinks[0].agent;
        self.defaultBrokerSelected = true;
    }

    selectBroker(broker, brokerType) {
        let self = this;

        if (brokerType == self.BROKER_TYPE_MAIN) {
            if (self.selectedCoBroker && self.selectedCoBroker.user_id == broker.user_id) {
                self.brokerSelectionError = "MAIN AGENT and CO-BROKER AGENT can't be same.";
                return;
            }
            self.selectedBroker = broker;
        } else {
            if (self.selectedBroker && self.selectedBroker.user_id == broker.user_id) {
                self.brokerSelectionError = "MAIN AGENT and CO-BROKER AGENT can't be same.";
                return;
            }
            self.selectedCoBroker = broker;
        }
        self.brokerSelectionError = "";

        //re calculate self.proceedButtonEnabled
        self.shallEnableProceedButton(self.STATE_STEP_4_SELECT_AGENT);
    }

    unselectBroker(brokerType) {
        let self = this;

        if (brokerType == self.BROKER_TYPE_MAIN) {
            if (self.defaultBrokerSelected && self.selectedBroker) {
                self.confirmDefaultBrokerChange = true;
                return;
            }
            self.selectedBroker = null;
        } else {
            self.selectedCoBroker = null;
        }

        //re calculate self.proceedButtonEnabled
        self.shallEnableProceedButton(self.STATE_STEP_4_SELECT_AGENT);
    }

    searchBroker(brokerType) {
        let self = this;

        let params = {};

        if (brokerType == self.BROKER_TYPE_MAIN) {
            params.criteria = self.searchBrokerCriteria.trim().toLocaleLowerCase();
            params.property_id = self.property.id;
        } else {
            params.criteria = self.searchCoBrokerCriteria.trim().toLocaleLowerCase();
        }

        self.SSHttpService.getAPIRequest(`agents/search`, params).then(
            function (response) {
                if (response instanceof Error) {
                    return;
                }

                if (brokerType == self.BROKER_TYPE_MAIN) {
                    self.brokersList = response.data.agents;
                } else {
                    self.allBrokersList = response.data.agents;
                }
            }
        );
    }

    toggleBuyerSelection(buyerItem) {
        const self = this;
        if (buyerItem.type !== self.USER_BUYER_TYPE_PRIMARY) {
            buyerItem.selected = !buyerItem.selected;
            self.shallEnableProceedButton();
        }
    }

    onNationalityChange(buyerItem) {
        let self = this;

        let form = jQuery('#buyerForm' + buyerItem.id);

        let inputCountry = jQuery(form.find('#country'));
        let inputNationalId = jQuery(form.find('#national_id'));
        let inputPassportNo = jQuery(form.find('#passport_no'));

        if (buyerItem.nationality === self.IDENTITY_TYPE_SINGAPOREAN) {
            //buyerItem.country = 702;
            inputCountry.val(702); // I don't know why above line is not working properly :(
        } else if (inputCountry.val() === "702" || inputCountry.val() === 702) {
            buyerItem.country = null;
            inputCountry.val('');
        } else {
            inputCountry.val(buyerItem.country);
        }

        if (buyerItem.nationality === self.IDENTITY_TYPE_FOREIGNER) {
            buyerItem.national_id = '';
            inputNationalId.attr('required', false);

            inputPassportNo.attr('required', true);
        } else {
            inputNationalId.attr('required', true);

            buyerItem.passport_no = '';
            inputPassportNo.attr('required', false);
        }
    }

    validateNRICWrapper(buyerItem) {
        const self = this;

        let form = jQuery('#buyerForm' + buyerItem.id);
        let field = jQuery(form.find('#national_id'));

        if (field.attr('disabled')) return true;

        if (validateNRIC(buyerItem.national_id)) { // The library function from nric-validation.js
            field.parent().removeClass("has-danger");
            return true;
        } else {
            field.parent().addClass("has-danger");
            return false;
        }
    }

    validatePassport(buyerItem) {
        const self = this;

        let form = jQuery('#buyerForm' + buyerItem.id);
        let field = jQuery(form.find('#passport_no'));

        if (field.attr('disabled')) return true;

        let pattern = /^[A-Za-z0-9]{6,10}$/

        if (pattern.test(buyerItem.passport_no)) {
            field.parent().removeClass("has-danger");
            return true;
        } else {
            field.parent().addClass("has-danger");
            return false;
        }
    }

    saveBuyer(buyerItem) {
        let self = this;

        self.setUserMessage('', '');

        buyerItem.isBusy = true;

        let form = jQuery('#buyerForm' + buyerItem.id);
        let inputCountry = jQuery(form.find('#country'));
        buyerItem.country = parseInt(inputCountry.val()); // A work-through for dropdown issue

        if (!self.SSUtilService.validatePostcode(buyerItem.country, buyerItem.postcode)) return;

        if (!self.SSUtilService.validateForm(buyerItem, 'buyerItem', jQuery('#buyerForm' + buyerItem.id))) return;
        if (!self.validateNRICWrapper(buyerItem)) return;
        if (!self.validatePassport(buyerItem)) return;

        let ignoreFields = ['selected', 'modeUpdate'];
        let bkpItem = self.buyersListBackup[buyerItem.id];
        let changed = self.hasChange(bkpItem, buyerItem, ignoreFields);

        let buyerItemCopy = angular.copy(buyerItem);
        let isNewBuyer = self.isNewDataModel(buyerItemCopy);
        if (isNewBuyer) {
            delete buyerItemCopy.id;
        }

        if (changed) {
            loading(true);
            self.addOrUpdateBuyer(buyerItemCopy).then(function (success, response) {
                loading(false);
                if (success) {
                    let buyer = response;
                    buyerItem.id = buyer.id;
                    self.saleBuyer = response;
                    buyerItem.customer_user_id = buyer.customer_user_id;
                    buyerItem.modeUpdate = false;
                    self.buyersListBackup[buyerItem.id] = _.cloneDeep(buyerItem);
                    self.saleErrorMessage = null;
                    if (isNewBuyer) {
                        buyerItem.selected = true;
                    }
                    self.setUserMessage('success', 'Buyer\'s Particulars update successfully.');
                    self.successBuyer = true;
                } else {
                    self.saleErrorMessage = JSON.stringify(response);
                    self.errorObject = response;
                    self.showAlertForFieldsError();
                    self.proceedButtonEnabled = false;
                }
                buyerItem.isBusy = false;
                self.shallEnableProceedButton();
            });
        } else {
            buyerItem.isBusy = false;
            buyerItem.modeUpdate = false;
            self.shallEnableProceedButton();
        }
    }

    hasChange(obj1, obj2, ignoreFields) {

        let change = false;

        if (!obj1 && !obj2) return false; // both are none
        if (!obj1 || !obj2) return true; // one is none and other is not

        let keys1 = Object.getOwnPropertyNames(obj1);
        let keys2 = Object.getOwnPropertyNames(obj2);
        var keys = angular.merge(keys1, keys2);

        _.forEach(keys, function (key) {
            if (ignoreFields && ignoreFields.indexOf(key) !== -1)
                return;
            if (obj1[key] != obj2[key])
                change = true;
        });

        return change;
    }

    cancelBuyer() {
        let self = this;

        _.forEach(self.buyersList, function (buyerItem) {
            if (buyerItem.modeUpdate) {
                buyerItem.modeUpdate = false;

                if (self.isNewDataModel(buyerItem)) {
                    _.remove(self.buyersList, buyerItem);
                } else {
                    var bkpItem = self.buyersListBackup[buyerItem.id];
                    angular.merge(buyerItem, bkpItem); // Merge props from backup to current item
                }
            }
        });

        self.shallEnableProceedButton();
    }

    fillDeveloperForms(allPropertyDocuments) {
        let developerDocuments = [];
        _.forEach(allPropertyDocuments, function (propertyDocument) {
            if (_.has(propertyDocument, 'for_each_buyer') && propertyDocument.for_each_buyer == 0) {
                developerDocuments.push(propertyDocument);
            }
        });

        return developerDocuments;
    }

    /**
     * Fill local array of buyerDocuments i.e create local in memory copy for document required from each buyer
     */
    fillBuyerDocuments() {
        const self = this;

        self.buyerDocuments = [];

        _.forEach(self.buyersList, function (buyerItem) {
            if (!buyerItem.selected) return;

            let requiredDocuments = {};

            _.forEach(self.propertyDocuments, function (propertyDocument) {
                if (propertyDocument.type !== self.PROPERTY_DOCUMENT_TYPE_USER_DOC)
                    return;
                if (!propertyDocument.for_each_buyer && buyerItem.type !== self.USER_BUYER_TYPE_PRIMARY)
                    return;
                if ((buyerItem.nationality === self.IDENTITY_TYPE_SINGAPOREAN || buyerItem.nationality === self.IDENTITY_TYPE_SINGAPORE_PR) &&
                    (propertyDocument.document_kind !== self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT && propertyDocument.document_kind !== self.PROPERTY_DOCUMENT_KIND_NRIC_BACK))
                    return;
                if (buyerItem.nationality === self.IDENTITY_TYPE_FOREIGNER && propertyDocument.document_kind !== self.PROPERTY_DOCUMENT_KIND_PASSPORT)
                    return;

                propertyDocument.id = null; // we don't need property document id
                requiredDocuments[propertyDocument.document_kind] = _.clone(propertyDocument, true);
            });

            _.forEach(buyerItem.documents, function (buyerDocument) {
                if (buyerDocument.document_kind in requiredDocuments) {
                    requiredDocuments[buyerDocument.document_kind] = buyerDocument;
                }
            });

            self.buyerDocuments[buyerItem.id] = _.values(requiredDocuments);

        });

    }

    viewDeveloperForm(saleDocument) {
        const self = this;

        if (saleDocument.file_uri) {
            let url = self.SSUtilService.makeAssetUrl(saleDocument.file_uri);
            self.SSUtilService.openUrlInNewTab(url);
            return;
        }
        if (saleDocument.document.pdf_file_uri) {
            let url = self.SSUtilService.makeAssetUrl(saleDocument.document.pdf_file_uri);
            self.SSUtilService.openUrlInNewTab(url);
            return;
        }

        let mainBuyer = null;
        _.forEach(self.saleBuyers, function (buyer) {
            if (buyer.type === self.USER_BUYER_TYPE_PRIMARY) {
                mainBuyer = buyer;
                return false;
            }
        });

        let documentSignee = null;
        _.forEach(saleDocument.document.document_signees, function (_document_signee) {
            if (_document_signee.email == mainBuyer.email) {
                documentSignee = _document_signee;
                return false;
            }
        });

        let url = 'pub/documents/' + saleDocument.document.id + '?signee_token=' + documentSignee.token;
        url = self.SSHttpService.getApiURL(url);

        $('#document_container').empty();
        $('#document_container').html('<iframe style="width:100%; height:100%;" src="' + url + '"></iframe>');

        self.documentToSign = saleDocument; // Show Popup
        jQuery('#documentToSign').modal('show');
    }

    signDeveloperForm(status) {
        const self = this;

        let saleDocument = self.documentToSign;

        let mainBuyer = null;
        _.forEach(self.saleBuyers, function (buyer) {
            if (buyer.type === self.USER_BUYER_TYPE_PRIMARY) {
                mainBuyer = buyer;
                return false;
            }
        });

        let documentSignee = null;
        _.forEach(saleDocument.document.document_signees, function (_document_signee) {
            if (_document_signee.email == mainBuyer.email) {
                documentSignee = _document_signee;
                return false;
            }
        });

        let url = 'pub/documents/' + saleDocument.document.id + '/sign';
        let params = {
            signee_token: documentSignee.token,
        };

        self.SSHttpService.postAPIRequest(url, params).then(
            function (responseObj) {
                if (responseObj instanceof Error) {
                    self.setUserMessage('danger', 'Error signing document. Please retry.');
                    return;
                }

                documentSignee.signed_at = new Date();
                self.documentToSign.signed = true;
                self.documentToSign.allSigned = responseObj.data.all_signed;

                self.documentToSign = null;
                jQuery('#documentToSign').modal('hide');

                self.shallEnableProceedButton();
            }
        );

    }

    printDeveloperForm(developerForm) {
        const self = this;

        self.SSUtilService.openUrlInNewTabForPrint(self.SSAppService.getAssetUrl(developerForm.file_uri));
    }

    saveBuyerDocument(userBuyer, buyerDocument, file) {
        const self = this;

        self.getPolicyDocument().then(function (success, policyDoc) {
            if (success) {
                self.policyDocData = policyDoc;
                let uploadPath = `${policyDoc.path}/${userBuyer.id}/`;

                uploadPath += self.SSUtilService.getRandomName(40 - uploadPath.length);

                self.uploadFile(file, uploadPath, self.policyDocData).then(function (data) {

                        let apiURI = `sec/buyers/${userBuyer.id}/documents`;
                        let prvURI = buyerDocument.file_uri;

                        buyerDocument.file_uri = data.file_uri;

                        self.SSHttpService.postAPIRequest(apiURI, buyerDocument).then(function (responseObj) {
                            buyerDocument.progressUploadingFile = false;

                            if (responseObj instanceof Error) {
                                self.SSUtilService.logError("Error in updating user buyer document: " + JSON.stringify(responseObj));
                                self.saleErrorMessage = JSON.stringify(responseObj);
                                buyerDocument.file_uri = prvURI;
                                self.showAlertForFieldsError();
                                return;
                            }

                            angular.merge(buyerDocument, responseObj.data.buyer_document);

                            var found = false;
                            _.forEach(userBuyer.documents, function (_buyerDocument) {
                                if (_buyerDocument.id === buyerDocument.id) {
                                    angular.merge(_buyerDocument, buyerDocument);
                                    found = true;
                                    return false;
                                }
                            });
                            if (!found) {
                                if (!userBuyer.documents)
                                    userBuyer.documents = [];
                                userBuyer.documents.push(buyerDocument);
                            }

                            self.saleErrorMessage = null;
                            self.shallEnableProceedButton(self.STATE_STEP_2_UPLOAD_DOC);
                        });
                    },
                    function () {
                        //failure
                        buyerDocument.uploadProgress = 0;
                        buyerDocument.progressUploadingFile = false;
                    },
                    function (progressPercentage) {
                        //progress
                        buyerDocument.uploadProgress = progressPercentage;
                        buyerDocument.progressUploadingFile = true;
                    });
            } else {
                //policy doc failure

            }
        });
    }

    removeBuyerDocument(userBuyer, buyerDocument) {
        const self = this;

        if (buyerDocument.id !== undefined) {

            let url = `sec/buyers/${userBuyer.id}/documents/${buyerDocument.id}/delete`;
            self.loadingIndicator = true;

            self.SSHttpService.getAPIRequest(url).then(
                function (responseObj) {
                    self.loadingIndicator = false;

                    if (responseObj instanceof Error) {
                        console.log(responseObj.message + "\n" + JSON.stringify(responseObj.data));
                        ;
                        self.SSUtilService.logError("Error fetching Result: " + JSON.stringify(responseObj.data));
                        return;
                    }

                    buyerDocument.id = null;
                    buyerDocument.file_uri = null;
                }
            );
        }

        self.shallEnableProceedButton(self.STATE_STEP_2_UPLOAD_DOC);
    }

    viewBuyerDocument(buyerDocument) {
        const self = this;

        if (buyerDocument.id) {
            let url = `sec/assets/presigned-url`;
            let params = {
                'model': self.ASSET_MODEL.UserBuyerDocument,
                'id': buyerDocument.id
            };

            self.loadingIndicator = true;
            self.SSHttpService.getAPIRequest(url, params).then(
                function (responseObj) {
                    self.loadingIndicator = false;
                    if (responseObj instanceof Error) {
                        console.log(responseObj.message + "\n" + JSON.stringify(responseObj.data));
                        ;
                        self.SSUtilService.logError("Error fetching Result: " + JSON.stringify(responseObj.data));
                        return;
                    }
                    self.SSUtilService.openUrlInNewTab(responseObj.data.presigned_url);
                }
            );
        }
    }

    checkPromotionCode() {
        const self = this;

        let promotionCodeInput = jQuery('#promotionCode');
        promotionCodeInput.parent().removeClass('has-danger');

        self.promotionCodeData = null;
        self.promotionCodeDesc = null;
        self.promotionCodeError = null;

        if (!self.sale.promotion_code || self.sale.promotion_code.length !== 6) {
            //
        } else {

            let url = `sec/promotion-code/check`;
            let params = {
                'unit_id': self.unit.id,
                'code': self.sale.promotion_code
            };

            promotionCodeInput.attr('disabled', true);

            loading(true, 0.2);

            self.SSHttpService.getAPIRequest(url, params).then(
                function (responseObj) {
                    loading(false);
                    promotionCodeInput.attr('disabled', false);

                    if (responseObj instanceof Error) {
                        promotionCodeInput.parent().addClass('has-danger');
                        self.promotionCodeError = "Invalid Code";
                        //self.shallEnableProceedButton();
                        return;
                    }

                    self.promotionCodeData = responseObj.data.promotion_code;

                    if (self.promotionCodeData.discount_type == self.PROMOTION_DISCOUNT_TYPE.AMOUNT) {
                        self.promotionCodeDesc = '$' + self.promotionCodeData.discount_value;
                    } else {
                        self.promotionCodeDesc = self.promotionCodeData.discount_value + '%';
                    }

                    if (self.promotionCodeData.discount_type == self.PROMOTION_DISCOUNT_TYPE.PERCENTAGE) {
                        self.sale.price = self.unit.price * ((100 - self.promotionCodeData.discount_value) / 100);
                    } else if (self.promotionCodeData.discount_type == self.PROMOTION_DISCOUNT_TYPE.AMOUNT) {
                        self.sale.price = self.unit.price - self.promotionCodeData.discount_value;
                    }

                    //self.shallEnableProceedButton();
                }
            );
        }
    }

    saveSaleBuyers() {
        const self = this;

        let url = 'sec/sales/buyers';
        let params = {
            unit_id: self.unit.id,
            user_buyer_ids: []
        };

        _.forEach(self.buyersList, function (userBuyer) {
            if (userBuyer.selected) {
                params.user_buyer_ids.push(userBuyer.id);
            }
        });

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(
            function (responseObj) {
                loading(false);
                if (responseObj instanceof Error) {
                    console.log(responseObj.message + "\n" + JSON.stringify(responseObj.data));
                    self.setUserMessage('danger', 'Unable to save buyer details. Please retry and if problem persists contact Showsuite support.');
                    return;
                }

                self.saleBuyers = responseObj.data.sale_buyers;

                console.log(self.saleBuyers);
                self.fillBuyerDocuments();
                self.goNextStep();
            }
        );

    }

    finalizeSale() {
        let self = this;

        let agency_id = null;
        let main_broker_user_id = null;
        let co_broker_user_id = null;

        if (self.isCoBrokerEnabled) {
            main_broker_user_id = self.selectedCoBroker.user_id;
            co_broker_user_id = self.selectedBroker.user_id;
            agency_id = self.selectedBroker.agency_id;
        } else {
            main_broker_user_id = self.selectedBroker.user_id;
            agency_id = self.selectedBroker.agency_id;
        }

        let finalObj = {
            "unit_id": self.unit.id,
            "agency_id": agency_id,
            "broker_user_id": main_broker_user_id,
            "co_broker_user_id": co_broker_user_id,
            "others": {
                "own_hdb": self.own_hdb,
                "own_other": self.own_other
            },
            "remarks": self.remarks,
        };

        self.saleLoading = true;
        loading(true);

        self.SSHttpService.postAPIRequest(`sec/sales/confirm`, finalObj).then(
            function (responseObj) {

                self.saleLoading = false;
                loading(false);

                if (responseObj instanceof Error) {
                    self.SSUtilService.logError(responseObj);
                    self.saleSuccess = false;
                    self.saleErrorMessage = JSON.stringify(responseObj);
                    self.errorObject = responseObj;
                    self.showAlertForFieldsError();
                    return;
                }

                self.saleErrorMessage = null;
                self.unit.status = self.UNIT_STATUS_BOOKED;
                self.saleSuccess = true;

            });
    }

    //printBookingConfirmation(divName) {
    //    if (self.bookingState == self.STATE_STEP_5_CONFIRMATION)
    //    {
    //        if(self.saleSuccess){
    //            $('#divHide').hide();
    //        }
    //        self.saleLoading = true;
    //        self.saleSuccess = true;
    //        var DocumentContainer = document.getElementById(divName).innerHTML;
    //        var WindowObject = window.open('', 'PrintWindow', 'width=750,height=650,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes');
    //        var str = "<style type='text/css' media='print' href='https://local.showsuite.com/customer/css/style.css'>"; //Add Your stylesheet here....!!
    //        str = str + ".txtboxborder{background:red;border-width:2px;}";
    //        str = str + "</style>";
    //        WindowObject.document.writeln(str);
    //        WindowObject.document.writeln(DocumentContainer);
    //
    //
    //        WindowObject.document.close();
    //        WindowObject.focus();
    //        WindowObject.print();
    //        WindowObject.close();
    //    }
    //
    //
    //}
    ////////######## Same Functions in the file so first one commented; #####/////
    //trackUnitViews() {
    //    const self = this;
    //
    //    let url = 'track/view/units/' + self.unitId;
    //    let params = {
    //        unit_id: self.unitId
    //    };
    //
    //    self.SSHttpService.postAPIRequest(url, params).then(
    //        function (responseObj) {
    //            if (responseObj instanceof Error) {
    //                console.log(responseObj.message + "\n" + JSON.stringify(responseObj.data));
    //                return;
    //            }
    //
    //            let finalObj = {
    //                "unit_id": self.unit.id,
    //                "agency_id": agency_id,
    //                "broker_user_id": main_broker_user_id,
    //                "co_broker_user_id": co_broker_user_id,
    //                "others": {
    //                    "own_hdb": self.own_hdb,
    //                    "own_other": self.own_other
    //                },
    //                "remarks": self.remarks,
    //            };
    //
    //            self.saleLoading = true;
    //            loading(true);
    //
    //            self.SSHttpService.postAPIRequest(`sec/sales/confirm`, finalObj).then(
    //                function (responseObj) {
    //
    //                    self.saleLoading = false;
    //                    loading(false);
    //
    //                    if (responseObj instanceof Error) {
    //                        self.SSUtilService.logError(responseObj);
    //                        self.saleSuccess = false;
    //                        self.saleErrorMessage = JSON.stringify(responseObj);
    //                        self.errorObject = responseObj;
    //                        self.showAlertForFieldsError();
    //                        return;
    //                    }
    //
    //                    self.saleErrorMessage = null;
    //                    self.unit.status = self.UNIT_STATUS_BOOKED;
    //                    self.saleSuccess = true;
    //                });
    //
    //        });
    //}

    showAlertForFieldsError() {
        let self = this;

        if (self.saleErrorMessage != null) {
            self.saleErrorMessage = JSON.parse(self.saleErrorMessage);
            var errorMessage = '';
            errorMessage += self.saleErrorMessage.serverMessage ? self.saleErrorMessage.serverMessage + ' ' : '';
            _.forOwn(self.saleErrorMessage.data, function (value, key) {
                errorMessage += value[0] + ' ';
            });
            if (!errorMessage) {
                errorMessage = 'Oops, something went wrong. Please make sure you have provided accurate information and retry.';
            }
            self.setUserMessage('danger', errorMessage);
        }
    }


    /***
     *        o      oooooooooo ooooo        oooooooo8     o      ooooo       ooooo        oooooooo8
     *       888      888    888 888       o888     88    888      888         888        888
     *      8  88     888oooo88  888       888           8  88     888         888         888oooooo
     *     8oooo88    888        888       888o     oo  8oooo88    888      o  888      o         888
     *   o88o  o888o o888o      o888o       888oooo88 o88o  o888o o888ooooo88 o888ooooo88 o88oooo888
     */

    getPolicyDocument() {
        const self = this;

        return {
            then: function (callback) {
                if (self.policyDocData !== undefined) {
                    callback(true, self.policyDocData);
                } else {
                    self.SSHttpService.getAPIRequest('sec/buyers/s3-policy-document').then(function (responseObj) {
                        if (responseObj instanceof Error) {
                            callback(false, responseObj);
                            return;
                        }
                        callback(true, responseObj.data.policy);
                    });

                }
            }
        }
    }

    addOrUpdateBuyer(buyerItem) {
        const self = this;
        self.loadingIndicator = true;

        return {
            then: function (callback) {
                if (!_.has(buyerItem, "id")) { //add new record;
                    //self.SSHttpService.postAPIRequest(`sec/buyers`, JSON.stringify(buyerItem)).then(
                    self.SSHttpService.postAPIRequest(`sec/buyers`, buyerItem).then(
                        function (responseObj) {
                            self.loadingIndicator = false;

                            if (responseObj instanceof Error) {
                                self.SSUtilService.logError("Error fetching Result: " + JSON.stringify(responseObj.data));
                                callback(false, responseObj);
                                return;
                            }
                            callback(true, responseObj.data.buyer);

                        });
                } else {
                    //self.SSHttpService.putAPIRequest(`sec/buyers/${buyerItem.id}`, JSON.stringify(buyerItem)).then(
                    self.SSHttpService.putAPIRequest(`sec/buyers/${buyerItem.id}`, buyerItem).then(
                        function (responseObj) {
                            self.loadingIndicator = false;

                            if (responseObj instanceof Error) {
                                console.log(responseObj.message + "\n" + JSON.stringify(responseObj.data));
                                ;
                                self.SSUtilService.logError("Error fetching Result: " + JSON.stringify(responseObj.data));
                                callback(false, responseObj);
                                return;
                            }

                            callback(true, responseObj.data.buyer);
                        });
                }
            }
        }
    }

    deleteBuyer(buyerItem) {
        const self = this;
        if (buyerItem.id !== undefined) {
            self.SSHttpService.getAPIRequest(`sec/buyers/${buyerItem.id}/delete`).then(
                function (responseObj) {
                    self.loadingIndicator = false;

                    if (responseObj instanceof Error) {
                        console.log(responseObj.message + "\n" + JSON.stringify(responseObj.data));
                        self.SSUtilService.logError("Error fetching Result: " + JSON.stringify(responseObj.data));
                        return;
                    }

                    buyerItem.modeUpdate = false;
                    _.remove(self.buyersList, buyerItem);
                });
        }
    }

    /***
     *         o  oooo     oooo oooooooo8               o88       oooooooo8    ooooooo
     *        888  88   88  88 888                     o88       888         o88    888o
     *       8  88  88 888 88   888oooooo            o88          888oooooo      88888o
     *      8oooo88  888 888           888         o88                   888 88o    o888
     *    o88o  o888o 8   8    o88oooo888        o88             o88oooo888    88ooo88
     *                                          o88
     */

    uploadFile(file, uploadPath, policyDoc) {
        const self = this;

        return {
            then: function (successCallback, failureCallback, inProgressCallback) {
                let policyAccessKey = policyDoc.key;
                let policy = policyDoc.document;
                let signature = policyDoc.signature;
                // TODO: Change hardcoded type 1 to user selected

                let fileExt = self.SSUtilService.getFileExtension(file.name);
                if (fileExt) {
                    uploadPath = `${uploadPath}.${fileExt}`;
                }

                self.progressUploadingFiles = true;
                self.Upload.upload({
                    url: self.appServiceObject.serverConfig.assets_host,
                    method: 'POST',
                    headers: {'Authorization': undefined},
                    data: {
                        key: uploadPath, // the key to store the file on S3, could be file name or customized
                        AWSAccessKeyId: policyAccessKey,
                        acl: 'public-read', // sets the access to the uploaded file in the bucket: private, public-read, ...
                        policy: policy, // base64-encoded json policy (see article below)
                        signature: signature, // base64-encoded signature based on policy string (see article below)
                        "Content-Type": '', // content type of the file (NotEmpty)
                        filename: uploadPath, // this is needed for Flash polyfill IE8-9
                        file: file
                    }
                }).then(function (resp) {
                    self.SSUtilService.log("success with key " + resp.config.data.key);
                    //Ad the asset to the property_assets
                    let fileParams = {
                        "file_uri": resp.config.data.key,
                        "name": resp.config.data.file.name
                    };
                    successCallback(fileParams);
                }, function (resp) {
                    self.SSUtilService.logError('Error status: ' + resp.status);
                    failureCallback();
                }, function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    self.SSUtilService.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    inProgressCallback(progressPercentage);
                });
            }
        }
    }

    printBookingConfirmation() {
        const self = this;
        let divName;
        if (self.bookingState == self.STATE_STEP_5_CONFIRMATION) {
            self.saleLoading = true;
            self.saleSuccess = true;
            if (self.saleSuccess) {
                divName = "divPrint";
            }
            else {
                $('#divHide').hide();
            }

            var DocumentContainer = document.getElementById(divName).innerHTML;
            var WindowObject = window.open('', 'PrintWindow', 'width=750,height=650,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes');
            var str = "<style type='text/css' media='print' href='http://local.showsuite.com/customer/css/style.css'>"; //Add Your stylesheet here....!!
            str = str + ".txtboxborder{background:red;border-width:2px;}";
            str = str + "</style>";
            WindowObject.document.writeln(str);
            WindowObject.document.writeln(DocumentContainer);


            WindowObject.document.close();
            WindowObject.focus();
            WindowObject.print();
            WindowObject.close();

        }
    }

    trackUnitViews() {
        const self = this;
        let url = 'track/view/units/' + self.unit.id;
        let params = {
            unit_id: self.unit.id
        };

        self.SSHttpService.postAPIRequest(url, params).then(
            function (responseObj) {
                if (responseObj instanceof Error) {
                    console.log(responseObj.message + "\n" + JSON.stringify(responseObj.data));
                    return;
                }
            }
        );
    }

    loadVideoCam(userBuyer, buyerDocument) {
        const self = this;

        self.scanDocumentStatus = true;

        self.$timeout(function () {
            self.startLoadVideoCam(userBuyer, buyerDocument)
        }, 100);


        //alert(Webcam.detectFlash());

        /*var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        var flashOrMediaIsAvai = false;

        if (isSafari) {

            if (Webcam.detectFlash()) {
                self.installAdobe = false;

                flashOrMediaIsAvai = true;
            } else {
                self.installAdobe = true;

                self.scanDocumentStatus = true;
                self.startCapture = false;
                //document.getElementById("native-start-capture").style.display = "none";
                self.doneCapture = false;
                //self.camErrorMsg = false;
                //document.getElementById("native-cam-errormsg").style.display = "none";
                document.getElementById("native-waiting-msg").style.display = "none";
            }
        } else {
            flashOrMediaIsAvai = true;
        }

        if (flashOrMediaIsAvai) {
            Webcam.set({
                width: 420,
                height: 320,
                image_format: 'jpeg',
                jpeg_quality: 90
            });
            Webcam.attach('#video');

            Webcam.reset();
            Webcam.set({
                width: 420,
                height: 320,
                image_format: 'jpeg',
                jpeg_quality: 90
            });
            Webcam.attach('#video');

            self.scanDocumentStatus = true;

            //self.startCapture = true;

            self.startCapture = true;
            //document.getElementById("native-start-capture").style.display = "none";
            document.getElementById("native-start-capture").style.display = "block";

            //self.waitngMsg = true;
            //document.getElementById("native-waiting-msg").style.display = "block";
            //document.getElementById("native-waiting-msg").style.display = "none";


            self.doneCapture = false;
            self.camErrorMsg = false;
            document.getElementById("native-cam-errormsg").style.display = "none";
            self.userBuyer = userBuyer;
            self.buyerDocument = buyerDocument;

            var photo = document.getElementById('capturedPhoto');
            photo.setAttribute('src', "");
        }*/

    }

    startLoadVideoCam(userBuyer, buyerDocument) {
        const self = this;

        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
         var flashOrMediaIsAvai = false;

         if (isSafari) {

         if (Webcam.detectFlash()) {
         self.installAdobe = false;

         flashOrMediaIsAvai = true;
         } else {
         self.installAdobe = true;

         self.scanDocumentStatus = true;
         self.startCapture = false;
         //document.getElementById("native-start-capture").style.display = "none";
         self.doneCapture = false;
         //self.camErrorMsg = false;
         //document.getElementById("native-cam-errormsg").style.display = "none";
         document.getElementById("native-waiting-msg").style.display = "none";
         }
         } else {
         flashOrMediaIsAvai = true;
         }

         if (flashOrMediaIsAvai) {
             Webcam.set({
                 width: 420,
                 height: 320,
                 image_format: 'jpeg',
                 jpeg_quality: 90
             });

             //Webcam.flashNotify('cameraLive');

             Webcam.attach('#video');

             self.scanDocumentStatus = true;

             //self.startCapture = true;

             self.startCapture = true;
             //document.getElementById("native-start-capture").style.display = "none";
             document.getElementById("native-start-capture").style.display = "block";

             //self.waitngMsg = true;
             //document.getElementById("native-waiting-msg").style.display = "block";
             //document.getElementById("native-waiting-msg").style.display = "none";


             self.doneCapture = false;
             self.camErrorMsg = false;
             document.getElementById("native-cam-errormsg").style.display = "none";
             self.userBuyer = userBuyer;
             self.buyerDocument = buyerDocument;

             var photo = document.getElementById('capturedPhoto');
             photo.setAttribute('src', "");
         }

    }

    dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        var byteString = atob(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        //New Code
        return new Blob([ab], {type: mimeString});


    }

    camCapture() {
        const self = this;

        // take snapshot and get image data
        Webcam.snap(function (data_uri) {
            // display results in page

            var photo = document.getElementById('capturedPhoto');
            //context.drawImage(self.video, 0, 0, 400, 300);
            photo.setAttribute('src', data_uri);

            self.blobObj = self.dataURItoBlob(data_uri);

        });

        self.startCapture = false;
        document.getElementById("native-start-capture").style.display = "none";

        self.waitngMsg = false;
        document.getElementById("native-waiting-msg").style.display = "none";

        self.doneCapture = true;

    }

    reCapture() {
        const self = this;

        self.startCapture = true;
        document.getElementById("native-start-capture").style.display = "block";

        self.waitngMsg = false;
        document.getElementById("native-waiting-msg").style.display = "none";

        var photo = document.getElementById('capturedPhoto');
        photo.setAttribute('src', "");

        self.doneCapture = false;
    }

    doneWithCam() {
        const self = this;

        self.scanDocumentStatus = false;
        //self.localMediaStream.stop();
        Webcam.reset();

        self.saveBuyerDocument(self.userBuyer, self.buyerDocument, self.blobObj);
    }

    closeCamModel() {
        const self = this;

        //var isChrome = !!window.chrome;

        if (self.startCapture || self.doneCapture) {
            //if (isChrome) {
            //    video.pause();
            //    video.src = "";
            //self.localMediaStream.stop();
            //}

            Webcam.reset();

            //self.localMediaStream.getTracks().forEach(function (track) {
            //    track.stop();
            //});
        }
        self.scanDocumentStatus = false;
    }

    checkAdobeInstallation() {
        /*const self = this;

        if (Webcam.detectFlash()) {
            self.installAdobe = false;
            //alert("in function call if");
        } else {
            self.installAdobe = true;
            //alert("in function call else");
        }*/

    }

    toggleFullScreen(event) {
        const self = this;

        if (self.Fullscreen.isEnabled()) {
            self.Fullscreen.cancel();
        } else {
            if (!event) return;

            if (typeof event == "string") {
                self.Fullscreen.enable(document.getElementById(event));
            } else if (event.currentTarget.tagName === "BUTTON") {
                self.Fullscreen.enable(event.currentTarget.parentNode);
            } else {
                self.Fullscreen.enable(event.currentTarget);
            }
        }
    }

    toggleDownloadsModal(status) {
        const self = this;

        self.downloadsModal = status;
        $('#downloadsModal').modal(status ? 'show' : 'hide');
    }

    openCallPopUpModal() {
        const self = this;

        //Add to Firebase Analytics Event
        firebase.analytics().logEvent('UNIT_DT_CALL_CLICKS', 
            {
                'event_category': 'Unit Details page',
                'property': self.property.name,
                'unit': self.SSUtilService.getFullUnitNumber(self.unit)
            });

        if (self.hasCalledPropertyContactAPI) {
            $('#call-modal').modal('show');
        } else {
            self.getPropertyContactNumber();
        }
    }

    checkCallButtonActive() {
        const self = this;

        if (self.property) {
            if (self.property.contact_number || self.data.share_code) {
                self.callButtonActive = true;
            }
        }
    }

    prepareLoadShareCode() {
        const self = this;

        let url = "properties/" + self.property.id + "/track-share-link-back";
        let params = {
            share_code: self.data.share_code
        }
    
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
        });
    }

    showEnquireModal() {
        const self = this;

        //Add to Firebase Analytics Event
        firebase.analytics().logEvent('UNIT_DT_ENQUIRE_CLICKS', 
            {
                'event_category': 'Unit Details page',
                'property': self.property.name,
                'unit': self.SSUtilService.getFullUnitNumber(self.unit)
            });

        self.SSUserService.showEnquireModal(self.property, self.unit);
    }

    track360PhotoAnalytics() {
        const self = this;

        //Add to Firebase Analytics Event
        firebase.analytics().logEvent('UNIT_DT_360PHOTO_CLICKS', 
            {
                'event_category': 'Unit Details page',
                'property': self.property.name,
                'unit': self.SSUtilService.getFullUnitNumber(self.unit)
            });
    }

    track3DFloorPlanAnalytics() {
        const self = this;

        //Add to Firebase Analytics Event
        firebase.analytics().logEvent('UNIT_DT_3DFLOORPL_CLICKS', 
            {
                'event_category': 'Unit Details page',
                'property': self.property.name,
                'unit': self.SSUtilService.getFullUnitNumber(self.unit)
            });
    }

    trackUnitSpecAnalytics() {
        const self = this;

        //Add to Firebase Analytics Event
        firebase.analytics().logEvent('UNIT_DT_UNITSPEC_CLICKS', 
            {
                'event_category': 'Unit Details page',
                'property': self.property.name,
                'unit': self.SSUtilService.getFullUnitNumber(self.unit)
            });
    }

    trackMortgageAnalytics() {
        const self = this;

        //Add to Firebase Analytics Event
        firebase.analytics().logEvent('UNIT_DT_MORTGAGE_CALC_CLICKS', 
            {
                'event_category': 'Unit Details page',
                'property': self.property.name,
                'unit': self.SSUtilService.getFullUnitNumber(self.unit)
            });
    }

    showShareModal() {
        const self = this;

        //Add to Firebase Analytics Event
        firebase.analytics().logEvent('UNIT_DT_SHARE_CLICKS', 
            {
                'event_category': 'Unit Details page',
                'property': self.property.name,
                'unit': self.SSUtilService.getFullUnitNumber(self.unit)
            });

        self.SSAppService.showShareModal(self.property, self.unit)
    }

    trackImageAnalytics() {
        const self = this;

        //Add to Firebase Analytics Event
        firebase.analytics().logEvent('UNIT_DT_IMAGES_CLICKS', 
            {
                'event_category': 'Unit Details page',
                'property': self.property.name,
                'unit': self.SSUtilService.getFullUnitNumber(self.unit)
            });
    }

    show360PhotoShareModal() {
        const self = this;

        //Add to Firebase Analytics Event
        firebase.analytics().logEvent('UNIT_DT_360PHOTO_SHARE', 
            {
                'event_category': 'Unit Details page',
                'property': self.property.name,
                'unit': self.SSUtilService.getFullUnitNumber(self.unit)
            });

        self.SSAppService.showShareModal(self.property, self.unit, '360');
    }

    show3DFloorPlanShareModal() {
        const self = this;

        //Add to Firebase Analytics Event
        firebase.analytics().logEvent('UNIT_DT_3DFLOORPL_SHARE', 
            {
                'event_category': 'Unit Details page',
                'property': self.property.name,
                'unit': self.SSUtilService.getFullUnitNumber(self.unit)
            });

        self.SSAppService.showShareModal(self.property, self.unit, '3dmodel');
    }
}

CustomerUnitItemController.$inject = [
    '$scope', '$localStorage', '$interval', '$timeout', '$sce', '$window', '$cookies', '$location', '$parse', '$anchorScroll', '$document',
    'Upload', 'Fullscreen',
    'SSHttpService', 'SSUtilService', 'SSConfigService', 'SSAppService', 'SSUserService', 'SSDisclaimerService', 'OTPService'
];
app.controller('CustomerUnitItemController', CustomerUnitItemController);
